import { Link } from "react-router-dom";
import logo from "../../img/logo-black.png";
import "../../App.css";
import "../../style/Home.css";
import "../../style/Footer.css";

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer__inner">
        <div className="footer__col footer__brand">
          <img src={logo} alt="Fastline" className="footer__logo" />
        </div>

        <div className="footer-block"></div>

        <div className="footer__col">
          <h4 className="footer__title">Fastline</h4>
          <ul className="footer__list">
         
            <li><Link to="/legal-notice">Mentions légales</Link></li>
            <li><Link to="/terms-of-service">CGU</Link></li>
            <li><Link to="/terms-of-sale">CGV</Link></li>
            <li><Link to="/privacy-policy">Confidentialité</Link></li>
            <li><Link to="/cookie-policy">Cookies</Link></li>
          </ul>
        </div>

        <div className="footer__col">
          <h4 className="footer__title">Ressources</h4>
          <ul className="footer__list">
          <li><Link to="/blog">Blog</Link></li>
            <li><a href="mailto:contact@fastlineapp.com">Réclamations</a></li>
            <li><a href="mailto:contact@fastlineapp.com">Contact</a></li>
            <li>
              <a
                href="https://wa.me/message/NR5ALYUJYWENM1"
                target="_blank"
                rel="noopener noreferrer"
              >
                WhatsApp
              </a>
            </li>
            <li>
              <a
                href="https://www.tiktok.com/@fastlineapp.com?_r=1&_t=ZN-95VN4ddw4W6"
                target="_blank"
                rel="noopener noreferrer"
              >
                TikTok
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="footer__bottom">
        © {new Date().getFullYear()} Fastline — Tous droits réservés
      </div>
    </footer>
  );
}